import { Box, Button, Divider, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { ReleaseToDeconCard } from './ReleaseToDeconCard';
import {
  hubStatusBodySx,
  hubStatusFooterSx,
  hubStatusHeaderSx,
  hubStatusIconWrapSx,
} from './styles';
import { periverseTheme } from '@peritasai/ui-shared';

type HubStatusCardProps = {
  title: string;
  message: string;
  secondMessage?: string;
  onConfirm: () => void;
};

export const HubStatusCard = ({ title, message, secondMessage, onConfirm }: HubStatusCardProps) => (
  <ReleaseToDeconCard
    sx={{
      textAlign: 'left',
      gap: 0,
      padding: '0px',
      width: { xs: '596px', md: '100%' },
      maxWidth: '100%',
      alignItems: 'stretch',
    }}
  >
    <Box sx={hubStatusHeaderSx}>
      <Box sx={hubStatusIconWrapSx}>
        <ErrorOutlineIcon sx={{ color: periverseTheme.palette.warning.main, fontSize: '24px' }} />
      </Box>
      <Typography
        sx={{
          color: 'rgba(0, 0, 0, 0.87)',
          fontFamily: 'var(--fontFamily, "Helvetica Neue")',
          fontSize: '20px',
          fontWeight: 700,
          lineHeight: '32px',
          letterSpacing: '0.15px',
        }}
      >
        {title}
      </Typography>
    </Box>
    <Divider />
    <Box sx={hubStatusBodySx}>
      <Typography
        sx={{
          color: 'rgba(0, 0, 0, 0.6)',
          fontFamily: 'var(--fontFamily, "Helvetica Neue")',
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '24px',
          letterSpacing: '0.15px',
        }}
      >
        {message}
      </Typography>
      <Typography
        sx={{
          color: 'rgba(0, 0, 0, 0.6)',
          fontFamily: 'var(--fontFamily, "Helvetica Neue")',
          fontSize: '16px',
          fontWeight: 400,
          lineHeight: '24px',
          letterSpacing: '0.15px',
        }}
      >
        {secondMessage ?? 'Check the station is powered on and connected, then re-open the release session.'}
      </Typography>
    </Box>
    <Box sx={hubStatusFooterSx}>
      <Button variant="contained" onClick={onConfirm} sx={{ minWidth: '80px' }}>
        OK
      </Button>
    </Box>
  </ReleaseToDeconCard>
);
